import { api } from "@/api";
import {
  MonitorErrorGroup,
  MonitorErrorStatus,
} from "@/types/ApiResponses/Monitor";

export interface SetMonitorErrorStatusParams {
  fingerprint: string;
  status: MonitorErrorStatus;
}

export const setMonitorErrorStatus = async (
  props: SetMonitorErrorStatusParams
): Promise<MonitorErrorGroup> => {
  const res = await api.client.post(
    `/monitor/errors/${props.fingerprint}/status`,
    { status: props.status }
  );
  return res.data;
};
